@if ((loading$ | async) && !loadingMore()) {
  <div class="empty">
    <div class="spinner-border text-blue"></div>
  </div>
}

@else {
  @if (error$ | async) {
    <div class="empty">
      <div class="alert alert-danger m-0">
        {{ 'news.error' | translate }}
      </div>
    </div>
  }
  @else {
    @let items = items$ | async;
    @if (items != null && items.length > 0) {
      <div class="list-group list-group-flush">
        @for (item of items; track item.id) {
          <div class="list-group-item p-0">
            <app-news-item [item]="item" (newsClicked)="openNewsSlideout(item.id)"></app-news-item>
          </div>
        }
        <div>
          @if ((loading$ | async) && loadingMore()) {
            <div class="text-center p-2">
              <div class="spinner-border text-blue"></div>
            </div>
          }
          
          @else if (hasNextPage$ | async) {
            <button class="btn btn-link w-100" (click)="loadMore()">
              {{ 'news.loadMore' | translate }}
            </button>
          }
        </div>
      </div>
    }
    @else {
      <div class="empty">
        <div class="p-2">{{ 'news.noResult' | translate }}</div>
      </div>
    }
  }
}